// 手机铃声——主流程
const MainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `ringTone/index${i + 1}`,
  name: `ringToneIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/ringTone/index${i + 1}.vue`)
}))
const BranchRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `ringTone/branch/index${i + 1}`,
  name: `ringToneBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/ringTone/branch/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机铃声——主流程，开始
    ...MainRoutes,
    // 手机铃声——分支流程，开始
    ...BranchRoutes,


  ],
};
